<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_3514_34271)">
			<path
				d="M8.00004 1.3335C4.31337 1.3335 1.33337 4.3135 1.33337 8.00016C1.33337 11.6868 4.31337 14.6668 8.00004 14.6668C11.6867 14.6668 14.6667 11.6868 14.6667 8.00016C14.6667 4.3135 11.6867 1.3335 8.00004 1.3335ZM11.3334 10.3935L10.3934 11.3335L8.00004 8.94016L5.60671 11.3335L4.66671 10.3935L7.06004 8.00016L4.66671 5.60683L5.60671 4.66683L8.00004 7.06016L10.3934 4.66683L11.3334 5.60683L8.94004 8.00016L11.3334 10.3935Z"
				fill="#CE2020"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3514_34271">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

